import { render, staticRenderFns } from "./Co04Page.vue?vue&type=template&id=2f6ec28f"
import script from "./Co04Page.vue?vue&type=script&lang=js"
export * from "./Co04Page.vue?vue&type=script&lang=js"
import style0 from "./Co04Page.vue?vue&type=style&index=0&id=2f6ec28f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports